import Auth from '@/services/auth'
import Settings from '@/services/settings'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const resetEmail = async (context, email) => {
  return new Promise((resolve, reject) => {
    Auth.resetEmail(email).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const validate = async(context, payload) => {
  return new Promise((resolve, reject) => {
    Auth.resetEmail(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const getSystemSettings = async({ commit }) => {
  return new Promise((resolve, reject) => {
    Settings.load().then((response) => {
      commit('SET_SYSTEM_SETTINGS', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const changePassword = (context, payload) => {
  return new Promise((resolve, reject) => {
    Auth.changePassword(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const acceptTerms = (context) => {
  return new Promise((resolve, reject) => {
    Auth.acceptTerms().then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

export default {
  resetEmail,
  validate,
  changePassword,
  getSystemSettings,
  acceptTerms
}



// WEBPACK FOOTER //
// ./src/features/auth/store/actions.js